/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { borderRadius, colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

import { markupContentStyles, syntaxHighlightStyles } from 'src/styles/markup';

export const ReadmeContainer = styled.article`
  border: 1px solid ${token('color.border', colors.N30)};
  border-radius: ${borderRadius()}px;
  padding: ${token('space.200')};
  ${markupContentStyles};
  ${syntaxHighlightStyles};
`;

export const ReadmeHeader = styled.span`
  font: ${token('font.heading.small')};
  margin-top: ${token('space.300')};
`;

export const ReadmeIcon = styled.span`
  > span {
    vertical-align: sub;
  }
`;
